(($, Drupal, once) => {
  Drupal.behaviors.photoGalleryCarousel = {
    attach: (context) => {
      once('photoGalleryCarousel', '.js-photo-gallery', context).forEach(
        (element) => {
          const $element = $(element);
          // Remodal Init
          const $modal = $(`.js-gallery-modal-${$element.data('id')}`);
          let $splide;
          let $thumbnailSplide;
          let currentSlide = 0;

          // Remodal Options: https://github.com/VodkaBears/Remodal#options
          const remodalOptions = {
            hashTracking: false,
            modifier: 'photo-gallery-carousel',
          };

          $modal.remodal(remodalOptions);

          // Splide Init - while modal is opening
          $(document).on('opening', $modal, function initSplide() {
            const $splideWrapper = $modal.find('.main-splide');
            // Thumbnail slider: https://splidejs.com/v3/tutorials/thumbnail-slider/
            const $thumbnailWrapper = $modal.find('.thumbnails-splide');
            if ($splideWrapper.length && $thumbnailWrapper.length) {
              // Splide Options: https://splidejs.com/guides/options/
              const splideSlides =
                $thumbnailWrapper.find('.splide__slide').length;
              const thumbnails = {
                maxPerPage: {
                  desktop: 7,
                  tablet: 7,
                  mobile: 4,
                },
                width: {
                  desktop: 80,
                  tablet: 60,
                  mobile: 35,
                },
                gap: {
                  desktop: 10,
                  tablet: 6,
                  mobile: 4,
                },
              };
              const numPerPage = {
                desktop:
                  splideSlides < thumbnails.maxPerPage.desktop
                    ? splideSlides
                    : thumbnails.maxPerPage.desktop,
                tablet:
                  splideSlides < thumbnails.maxPerPage.tablet
                    ? splideSlides
                    : thumbnails.maxPerPage.tablet,
                mobile:
                  splideSlides < thumbnails.maxPerPage.mobile
                    ? splideSlides
                    : thumbnails.maxPerPage.mobile,
              };
              const maxWidth = {
                desktop:
                  numPerPage.desktop * thumbnails.width.desktop +
                  numPerPage.desktop * thumbnails.gap.desktop,
                tablet:
                  numPerPage.tablet * thumbnails.width.tablet +
                  numPerPage.tablet * thumbnails.gap.tablet,
                mobile:
                  numPerPage.mobile * thumbnails.width.mobile +
                  numPerPage.mobile * thumbnails.gap.mobile,
              };
              const splideOptions = {
                start: currentSlide,
                type: 'fade',
                rewind: true,
                gap: 24,
                pagination: false,
                trimSpace: 'move',
              };
              const thumbnailOptions = {
                start: currentSlide,
                updateOnMove: true,
                height: `${thumbnails.width.desktop}px`,
                gap: thumbnails.gap.desktop,
                rewind: true,
                pagination: false,
                cover: true,
                isNavigation: true,
                drag: false,
                trimSpace: 'move',
                focus: '2',
                perPage: numPerPage.desktop,
                perMove: 2,
                width: `${maxWidth.desktop}px`,
                breakpoints: {
                  992: {
                    gap: thumbnails.gap.tablet,
                    height: `${thumbnails.width.tablet}px`,
                    width: `${maxWidth.tablet}px`,
                    perPage: numPerPage.tablet,
                  },
                  576: {
                    gap: thumbnails.gap.mobile,
                    height: `${thumbnails.width.mobile}px`,
                    width: `${maxWidth.mobile}px`,
                    perPage: numPerPage.mobile,
                  },
                },
              };
              // eslint-disable-next-line no-undef
              $splide = new Splide($splideWrapper[0], splideOptions);
              // eslint-disable-next-line no-undef
              $thumbnailSplide = new Splide(
                $thumbnailWrapper[0],
                thumbnailOptions,
              );
              $splide.sync($thumbnailSplide);
              $splide.mount();
              $thumbnailSplide.mount();
            }
          });

          // Splide Refresh - after splide to determines the modal width
          $(document).on('opened', $modal, function initSplide() {
            $splide.refresh();
            $thumbnailSplide.refresh();
            $splide.sync($thumbnailSplide);
          });

          // Splide Destroy - once modal closes
          $(document).on('closed', $modal, function destroySplide() {
            $splide.destroy();
            $thumbnailSplide.destroy();
          });

          // Modal Triggers
          const $modalTriggers = $element.find('.js-modal-trigger');

          $modalTriggers.on('click', function updateCurrentSlide() {
            currentSlide = $(this).data('slide');
          });

          $modalTriggers.on('keydown', function updateCurrentSlide(e) {
            if (e.key === 'Enter') {
              $(this).click();
            }
          });
        },
      );
    },
  };
})(jQuery, Drupal, once);
